export const propsForMenuItems = {
  sx: {
    marginBottom: 0,
    py: "8px",
  },
};
